<template>
	<v-col class="sales-group">
		<DetailGroupOmset ref="detailGroupOmset"></DetailGroupOmset>
		<div class="d-flex justify-space-between">
			<div class="text-h5 cl-primary">Omset Grup</div>
		</div>
		<div class="pt-1 pb-2 d-flex font-size-10 grey--text">
			<v-icon small color="grey">mdi-credit-card-sync</v-icon>
			<div class="pl-2">Repeat Order</div>
			<div class="px-2">/</div>
			<div>Omset Grup</div>
		</div>
		<div class="mt-5">
			<v-row justify="end" justify-sm="space-between" class="pt-3 py-sm-3">
				<v-col cols="12" sm="12" md="4" order="2" order-sm="1">
					<v-card class="px-3 elevation-0 rounded-lg hover-shadow">
						<v-row>
							<v-col cols="2" sm="3" md="3" class="pr-0 my-auto">
								<v-img width="45" class="mx-auto" src="/assets/icon/serial_repeat_order.svg"></v-img>
							</v-col>
							<v-col cols="10" sm="9" md="9">
								<div class="font-size-14 cl-secondary font-weight-500">
									<div>{{ summaryPersonal | toNumber }}</div>
								</div>
								<div class="font-size-10 cl-grey">Total RO Personal</div>
							</v-col>
						</v-row>
					</v-card>
				</v-col>
				<v-col cols="12" sm="12" md="3" class="my-auto" order="1" order-sm="2">
					<v-row justify="end">
						<v-col cols="12" sm="12" md="12">
							<v-menu v-model="startDate" :close-on-content-click="false" :nudge-right="0" transition="scale-transition" offset-y min-width="290px">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field placeholder="Pilih Bulan" outlined dense append-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" background-color="white" class="rounded-lg date-no-border" hide-details :value="convertMonth(dateStart)"></v-text-field>
								</template>
								<v-date-picker locale="id" type="month" first-day-of-week="0" color="primary" :max="today" @input="startDate = false" @change="getData" v-model="dateStart"></v-date-picker>
							</v-menu>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
			<div class="mt-3" v-if="!loading">
				<v-row v-if="listGroupOmset.length > 0">
					<v-col cols="12" class="pt-0">
						<v-simple-table class="white-row table-vo table-history-transfer">
							<template v-slot:default>
								<thead class="">
									<tr>
										<th class="text-left">Kode Jalur Mitra</th>
										<th class="text-left" width="35%">Nama Jalur Mitra</th>
										<th class="text-center">Total RO</th>
										<th class="text-center">Detail</th>
									</tr>
								</thead>
								<tbody class="grey--text text--darken-3">
									<tr v-for="sales in listGroupOmset" :key="sales.sales_group_id">
										<td class="text-left cl-secondary font-weight-600">{{ sales.network_code }}</td>
										<td class="text-left">{{ sales.member_name }}</td>
										<td class="text-center">{{ sales.total_ro }}</td>
										<td class="text-center">
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-btn class="" fab dark x-small depressed color="primary" v-bind="attrs" v-on="on" @click="showDetail(sales.sales_group_line_network_id)">
														<v-icon dark>mdi-text-box-search</v-icon>
													</v-btn>
												</template>
												<span>Detail</span>
											</v-tooltip>
										</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
					</v-col>
				</v-row>
				<div class="mt-3" v-if="listGroupOmset.length == 0">
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<v-card class="py-3 elevation-0 hover-shadow rounded-lg">
								<NoData></NoData>
								<div class="pt-3 text-center cl-secondary">Tidak ada data omset grup yang dapat ditampilkan</div>
							</v-card>
						</v-col>
					</v-row>
				</div>
				<div v-if="listGroupOmset.length > 0">
					<v-row justify="end">
						<v-col cols="12" sm="5" md="6" class="pl-0 pr-0 pb-1 pr-sm-3 pb-sm-3 d-flex justify-sm-start justify-end">
							<v-pagination v-model="page" total-visible="5" class="d-flex justify-end vo-pagination no-button-focus" color="primary" :length="groupOmsetPagination.total_page" @input="changePage"></v-pagination>
						</v-col>
						<v-col cols="12" sm="5" md="5" class="pb-0 pb-sm-3 my-auto text-right">
							<div class=" font-size-10">Menampilkan {{ groupOmsetPagination.total_display }} data dari total {{ groupOmsetPagination.total_data }} data</div>
						</v-col>
						<v-col cols="4" sm="2" md="1">
							<v-autocomplete :items="listLimit" v-model="limit" hide-details dense class="" placeholder="Data" color="primary" @input="changeLimit"></v-autocomplete>
						</v-col>
					</v-row>
				</div>
			</div>
			<div class="mt-3" v-if="loading">
				<v-row>
					<v-col cols="12" sm="12" md="12">
						<LoadData :loading="loading"></LoadData>
					</v-col>
				</v-row>
			</div>
		</div>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import DetailGroupOmset from './components/DetailGroupOmset';
import moment from 'moment';
moment.locale('id');

export default {
	components: {
		DetailGroupOmset
	},
	data() {
		return {
			loading: false,
			startDate: false,
			dateStart: moment().format("YYYY-MM"),
			start: '',
			end: '',
			monthDate: new Date().getMonth() + 1,
			yearDate: new Date().getFullYear(),
			dayEnd: '31',
			page: 1,
			limit: '10',
			listLimit: [ '10', '20', '50', '100' ],
		}
	},
	computed: {
		...mapState('repeatOrder', ['listGroupOmset', 'groupOmsetPagination', 'summaryPersonal']),
	},
	methods: {
		...mapActions('repeatOrder', ['getGroupOmset', 'getDetailGroupOmset']),

		showDetail(id) {
			let params = {}
			params.line_network_id = id
			if (this.dateStart) {
				this.monthDate = moment(this.dateStart).format('MM')
				this.yearDate = moment(this.dateStart).format('YYYY')
				params.month = this.monthDate
				params.year = this.yearDate
			} else {
				params.month = this.monthDate
				params.year = this.yearDate
			}
			this.getDetailGroupOmset(params)
			this.$refs.detailGroupOmset.modalShow()
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		getData() {
			this.loading = true
			let params = {limit:this.limit, page: this.page}
			if (this.dateStart) {
				this.monthDate = moment(this.dateStart).format('MM')
				this.yearDate = moment(this.dateStart).format('YYYY')
				params.month = this.monthDate
				params.year = this.yearDate
			} else {
				params.month = this.monthDate
				params.year = this.yearDate
			}
			this.getGroupOmset(params).then(() => {
				document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
				this.loading = false
			})
		}
	},
	created() {
		this.$store.dispatch('setPageTitle', `Omset Grup`)
		this.getData()
	}
};
</script>

